import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SearchProvider } from "@/context/SearchContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import DashboardLayout from "@/components/DashboardLayout";
import Overview from "@/pages/Overview";
import Incidents from "@/pages/Incidents";
import Assets from "@/pages/Assets";
import Analytics from "@/pages/Analytics";
import Users from "@/pages/Users";
import Pentest from "@/pages/Pentest";
import Intercept from "@/pages/Intercept";
import RedTeam from "@/pages/RedTeam";
import CodeScan from "@/pages/CodeScan";
import NDays from "@/pages/NDays";
import MLDetection from "@/pages/MLDetection";
import ThreatIntel from "@/pages/ThreatIntel";
import Events from "@/pages/Events";

function App() {
  return (
    <AuthProvider>
      <SearchProvider>
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { fontFamily: "JetBrains Mono", borderRadius: 0 } }} />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="pentest" element={<Pentest />} />
              <Route path="intercept" element={<Intercept />} />
              <Route path="redteam" element={<RedTeam />} />
              <Route path="codescan" element={<CodeScan />} />
              <Route path="ndays" element={<NDays />} />
              <Route path="ml" element={<MLDetection />} />
              <Route path="intel" element={<ThreatIntel />} />
              <Route path="events" element={<Events />} />
              <Route path="incidents" element={<Incidents />} />
              <Route path="assets" element={<Assets />} />
              <Route path="endpoints" element={<Assets />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="users" element={<Users />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SearchProvider>
    </AuthProvider>
  );
}

export default App;
